export default __webpack_public_path__ + "static/media/event-image-2.871259cf.png";